// extracted by mini-css-extract-plugin
export default {"valiated_message":"style_valiated_message__ZkwOC","validated_failed":"style_validated_failed__I32Es","validated_success":"style_validated_success__4pWw+"};